import { createStyles, Grid, Theme, Typography } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import { DashboardPatterns } from "assets/jss/common-styles";
import { DoughnutCenterText } from "components/Dashboard/DashDoughnut";
import MuiBox from "components/MuiExtras/MuiBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import * as React from "react";
import { Doughnut } from 'react-chartjs-2';
import { WithTranslation, withTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////////////////

const styles = (theme: Theme) => createStyles({
    container: {
        width: "100%"
    },

    progressOuter: {
        position: "relative",
        backgroundColor: DashboardPatterns.knowlegdeBars.f3.backgroundColor,
        height: "8px",
        width: "100%"
    },
    progressInner: {
        position: "absolute",
        width: "12.5%",
        height: "8px",
        backgroundColor: DashboardPatterns.knowlegdeBars.f4.backgroundColor
    },
    progressLabel: {
        width: "25%",
        color: "#808080",
        textTransform: "uppercase",
        "&:last-child": {
            textAlign: "right"
        }
    },
    progressMarker: {
        width: "25%",
        borderLeftColor: DashboardPatterns.knowlegdeBars.f4.backgroundColor,
        borderLeftStyle: "solid",
        borderLeftWidth: "4px",
        height: "10px",
        "&:last-child": {
            borderRightColor: DashboardPatterns.knowlegdeBars.f4.backgroundColor,
            borderRightStyle: "solid",
            borderRightWidth: "4px",
        }
    },
    progressTable: {
        borderCollapse: "collapse",
        width: "100%"
    },
    currentLevel: {
        color: theme.genie.palette.warning.dark,
        fontWeight: "bold"
    }
});

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
}

interface IProps {
    topicName: string;
    topicThumbnailUrl: string;
    knowledgePercent: number;
}

type Props = IProps & WithStyles<typeof styles> & WithTranslation;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export class KnowledgeTopicLevel extends React.Component<Props, IState> {

    ///
    public render() {
        const { classes, knowledgePercent, topicName, topicThumbnailUrl } = this.props;

        const chartData = {
            labels: [
                this.props.t("Views.KnowledgeTest.Components.KnowledgeTopicLevel.ConqueredLabel"),
                this.props.t("Views.KnowledgeTest.Components.KnowledgeTopicLevel.ConqueringLabel"),
            ],
            datasets: [{
                data: [knowledgePercent, 100 - knowledgePercent],
                backgroundColor: [
                    DashboardPatterns.knowlegdeBars.f4.backgroundColor,
                    DashboardPatterns.knowlegdeBars.f3.backgroundColor
                ],
                hoverBackgroundColor: [
                    DashboardPatterns.knowlegdeBars.f4.backgroundColor,
                    DashboardPatterns.knowlegdeBars.f3.backgroundColor
                ],
                options: {
                    elements: {
                        center: {
                            text: `${knowledgePercent}%`,
                            color: '#3d5afe', // Default is #000000
                            fontStyle: 'Arial', // Default is Arial
                            sidePadding: 20 // Defualt is 20 (as a percentage)
                        }
                    },
                }
            }]
        };


        return (
            <MuiBox variant="notice">

                <MuiContainer>
                    <Grid container justifyContent="space-between" spacing={2}>
                        {
                            topicThumbnailUrl &&
                            <Grid item>
                                <img src={topicThumbnailUrl} alt={topicName} />
                            </Grid>
                        }
                        <Grid item xs>

                            <Typography variant="h6" component="p">
                                <b>{topicName}</b>
                            </Typography>
                            <MuiMuted>
                                <Typography variant="body2" >
                                    <div>{this.props.t("Views.KnowledgeTest.Components.KnowledgeTopicLevel.BodyText1", { value: knowledgePercent })}</div>
                                    {
                                        knowledgePercent < 100 &&
                                        <div>{this.props.t("Views.KnowledgeTest.Components.KnowledgeTopicLevel.BoxText2")}</div>
                                    }
                                </Typography>
                            </MuiMuted>
                        </Grid>
                    </Grid>
                </MuiContainer>

                <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                    <Grid item>
                        <Doughnut
                            width={150}
                            data={chartData}
                            options={
                                {
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        tooltip: {
                                            enabled: false
                                        }
                                    }
                                }
                            }
                            plugins={
                                [DoughnutCenterText]
                            }
                        />
                    </Grid>
                    <Grid item xs>
                        <div className="container">
                            <div className={classes.progressOuter}>
                                <div className={classes.progressInner} style={{ width: `${knowledgePercent}%` }}></div>
                            </div>
                            <table className={classes.progressTable}>
                                <tr>
                                    <td className={classes.progressMarker}></td>
                                    <td className={classes.progressMarker}></td>
                                    <td className={classes.progressMarker}></td>
                                    <td className={classes.progressMarker}></td>
                                </tr>
                                <tr>
                                    <td className={classes.progressLabel}>0%</td>
                                    <td className={classes.progressLabel}>25%</td>
                                    <td className={classes.progressLabel}>50%</td>
                                    <td className={classes.progressLabel}>
                                        <div style={{ float: "left" }}>75%</div>
                                        <div style={{ float: "right" }}>100%</div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Grid>
                </Grid>
            </MuiBox>
        );
    }
}

export default withTranslation()(withStyles(styles)(KnowledgeTopicLevel));